module.exports = __webpack_public_path__ + "static/media/mantras.22d017a1.png";